import { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
import { useI18n } from '@/i18n/I18nProvider';

const capitalize = (s: string) => s.charAt(0).toLocaleUpperCase() + s.slice(1);

/** Zegar w górnym pasku (styl ZUR OPS): kafelek z ikoną, godzina i data w lokalnym formacie. */
export function TopbarClock() {
  const { locale } = useI18n();
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = window.setInterval(() => setNow(new Date()), 15_000);
    return () => window.clearInterval(id);
  }, []);

  const time = now.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit', hour12: false });
  const date = capitalize(
    now.toLocaleDateString(locale, { weekday: 'short', day: 'numeric', month: 'short' }),
  );

  return (
    <div className="hidden items-center gap-3 xl:flex">
      <span className="flex size-10 items-center justify-center rounded-xl border border-sidebar-border bg-sidebar-accent text-[color:var(--brand-cyan)]">
        <Clock className="size-[18px]" aria-hidden />
      </span>
      <span className="whitespace-nowrap leading-tight">
        <span className="block text-[17px] font-bold tabular text-foreground">{time}</span>
        <span className="block text-[11px] font-semibold text-primary">{date}</span>
      </span>
    </div>
  );
}
